import {
  Component,
  EventEmitter,
  ElementRef,
  forwardRef,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { FileUploader } from 'ng2-file-upload';
import { MetaService } from '@bo-client/core/api/meta-service';
import { DocumentDto } from '@bo-client/shared/models/documentDto';
import { ConfigService } from '@bo-client/config/config.service';
import { DataShareService } from '@bo-client/shared/services/data-share.service';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FileUploadComponent),
      multi: true
    }
  ]
})
export class FileUploadComponent implements OnInit {
  @Input() inputDoc: DocumentDto;
  @Input() showFileName = false;
  @Input() disabledUploadButton = false;
  @Input() reloadDoc = false;
  @Input() validFormats: string[] = ['.pdf', '.png', '.jpg', '.jpeg', '.msg', '.eml'];
  @Input() tag = '';
  @Input() canUpdate = true;
  @Output() savedDoc = new EventEmitter<any>();
  @Output() errorByLoading = new EventEmitter<any>();
  @Output() onClick = new EventEmitter<void>();

  @ViewChild('myInput')
  myInputVariable: ElementRef;

  file: any;
  fileName: string;
  errorMessage: string;

  public uploader: FileUploader;
  public documentDto: DocumentDto;

  isBusy: boolean;
  value: string; //(This is the cok-doc id)

  constructor(
    public metaService: MetaService,
    private configService: ConfigService,
    private dataShareService: DataShareService
  ) {}

  ngOnInit() {
    const tenantId = this.dataShareService.selectedTenant.id;
    this.uploader = new FileUploader({
      url: this.configService.getSettings('serverUrl') + '/documents/upload',
      itemAlias: 'file',
      headers: [{ name: 'X-Tenant', value: tenantId }]
    });

    this.uploader.onAfterAddingFile = (file) => {
      console.log('AfterAddingFile');
      const extFileName = file._file.name.substr(file._file.name.lastIndexOf('.') + 1);
      if (this.checkValidFormats(extFileName)) {
        this.file = file;
        file.withCredentials = false;
        this.fileName = file._file.name;
        this.submit();
      } else {
        this.errorByLoading.emit('Format ' + extFileName + ' invalid');
      }
    };
    this.uploader.onCompleteItem = (item: any, response: string, status: number, headers: any) => {
      this.isBusy = false;
      if (status === 200) {
        this.documentDto = JSON.parse(response);
        this.documentDto.tag = this.tag;
        this.savedDoc.emit({
          documentDto: this.documentDto,
          saved: true
        });
      } else {
        this.savedDoc.emit({
          errorMessage: this.toErrorMessage(status, response),
          saved: false
        });
        this.errorMessage = this.toErrorMessage(status, response);
      }
    };
  }

  async submit() {
    this.isBusy = true;

    this.uploader.options.additionalParameter = {
      tag: this.tag
    };
    this.uploader.uploadItem(this.file);
  }

  reset() {
    // this.myInputVariable.nativeElement.value = "";
    this.value = null;
    this.file = null;
    // this.group.patchValue({ cokDockId: null, url: null, displayName: null })
  }

  retry() {
    this.submit();
  }

  toErrorMessage(status: number, response: string): string {
    switch (status) {
      case 0:
        return 'Ein Verbindungsfehler ist aufgetreten. Bitte versuchen Sie es erneut.';
      case 400:
        if (response.includes('Maximum upload size exceeded')) {
          return 'Fehler beim Hochladen Ihrer Datei: Die maximale Dateigröße wurde überschritten.';
        }
        return 'Fehler beim Hochladen Ihrer Datei: Die maximale Anzahl an Dokumenten wurde überschritten.';
      default:
        return 'Beim Upload der Datei ist ein Fehler aufgetreten: +' + status;
    }
  }

  checkValidFormats(extension: string): boolean {
    let isValid = false;
    if (this.validFormats) {
      isValid = this.validFormats.some((ele) => {
        return ele?.toLowerCase() === `.${extension}`?.toLowerCase();
      });
    }
    this.errorByLoading.emit(null);
    console.log('isValid', isValid);
    return isValid;
  }

  deleteFile() {
    this.reset();
    this.savedDoc.emit(null);
    this.errorByLoading.emit(null);
  }
}
